import moment from 'moment'
import { useCallback, useContext, useEffect, useRef, useState } from 'react'
import { useParams } from 'react-router-dom'
import { Button, Modal } from 'syngenta-react-components'
import TableStatus from '../../../components/subComponents/TableStatus/TableStatus'
import DetailView from '../../../dpe-usco/components/Details/DetailView'
import { getFieldsBySFDC_IDAndContractId, getGrower, getStewardshipDefaultData, patchStewardshipHistoryData, patchStewardshipTable, patchSilageStewardship } from '../../../services/apiHelper'
import { AuthContext, GlobalContext } from '../../../services/context'
import useApiHelper from '../../../services/useApiHelper'
import { nullParser, nullParserReverse } from '../../../services/utils'
import AccessDeniedView from '../../Interstitial/AccessDeniedView'
import AssignEnogenFieldsView from './AssignEnogenFieldsView'
import FieldLostView from './FieldLostView'
import HarvestSteward from './HarvestSteward'
import PlantingSteward from './PlantingSteward'
import ReplantView from './ReplantView'
import StewardshipSummary from './StewardshipSummary'
import StorageCleanout from './StorageCleanout'

const MAX_FALSEY_PLANTING_VALUES = 4
const MAX_FALSEY_HARVEST_VALUES = 6

export const plantingSummaryHandler = (arg1, arg2) => {
  let counter = 0
  if (arg1) {
    counter++
  }
  if (arg2) {
    counter++
  }
  if (counter === 2) {
    return true
  } else if (counter === 1) {
    return false
  }
  return null
}

const StewardshipDetailView = () => {
  const params = useParams()
  const canceled = useRef(false)

  const { hasAccess, hasStewardAccess } = useContext(AuthContext)
  const { dispatch, trackEvent } = useContext(GlobalContext)
  const { company_id, stewardship_activity_id } = params || {}
  const [allowAccess, setAllowAccess] = useState('LOADING')
  const [plantingData, setPlantingData] = useState([])
  const [harvestData, setHarvestData] = useState([])
  const [storageData, setStorageData] = useState([])
  const [activities, setActivities] = useState([])
  const [replantOrLost, setReplantOrLost] = useState([])
  const [fieldCompleteOrNot, setFieldCompleteOrNot] = useState([])
  const [showModal, setShowModal] = useState(false)
  const [modalContent, setModalContent] = useState()
  const [isActiveWidget, setIsActiveWidget] = useState()
  const [cachedObject, setCachedObject] = useState({})
  const [harvestCleanout, setHarvestCleanout] = useState(false)
  const [plantingCleanout, setPlantingCleanout] = useState(false)
  const [seedReturn, setSeedReturn] = useState(false)
  const [stewardshipStatus, setStewardshipStatus] = useState('LOADING')
  const [stewardshipSummaryDataArray, setStewardshipSummaryDataArray] = useState([])
  const [detailViewTitle, setDetailViewTitle] = useState('')
  const [contractFilterData, setContractFilterData] = useState({})
  const [isTotalfield, setIsTotalfield] = useState(false)
  const [showAssignEnogenFields, setShowAssignEnogenFields] = useState(false)
  const [fieldData, setFieldData] = useState({})
  const [fieldDataStatus, setFieldDataStatus] = useState('WAITING')
  const [init_fields, set_init_fields] = useState()
  const [sapId, setSapId] = useState('')
  const [patchPlantAndHarvestStatus, setPatchPlantAndHarvestStatus] = useState(false)
  const [userInfo, setUserInfo] = useState({})
  const [showFieldLost, setShowFieldLost] = useState(false)
  const [showReplant, setShowReplant] = useState(false)
  const [cleanoutSummaryData, setCleanoutSummaryData] = useState([
    {
      complete: 'Complete',
      planting_summary: null,
      harvest_summary: null,
      storage_summary: null
    }
  ])
  const [isLoading, setIsLoading] = useState(false)
  const [{ data: contractData, status: contractStatus }, getContractById] = useApiHelper('getContractById')
  const [stewardsUsers, setStewardsUsers] = useState([])
  const [silageDate, setSilageDate] = useState(null)

  const handleSetActiveWidget = widget => {
    if (widget) {
      const lower = widget.toLowerCase()
      trackEvent(`edit_${lower}_clicked`, { stewardshipActivityId: stewardship_activity_id })
    }
    setIsActiveWidget(widget)
  }

  const handleClose = result => {
    switch (result) {
      case 'SUCCESS':
        getStewardshipFieldsCall()
        break
      default:
        break
    }
    setShowModal(false)
  }

  const stewardshipSummaryHelper = (arr, type, maxEmptyStrings) => {
    return arr.map(obj => {
      let emptyStringCount = 0
      let result = true
      let resultObj = {
        name: obj.name
      }
      for (const prop in obj) {
        if (obj[prop] === '') {
          emptyStringCount++
        }
      }
      if (emptyStringCount === maxEmptyStrings) {
        result = null
      } else if (emptyStringCount < maxEmptyStrings && emptyStringCount > 0 && obj.is_silage_harvest !== true) {
        result = false
      }
      resultObj[type] = result
      return resultObj
    })
  }

  const setWidgetData = useCallback(res => {
    const _harvestCleanout = res?.activities?.cleanout?.harvest?.harvest_equipment || null
    const _plantingCleanout = res?.activities?.cleanout?.planting?.planting_equipment || null
    const _seedReturn = res?.activities?.cleanout?.planting?.seed_return || null
    // const plantingSummaryResult = plantingSummaryHandler(_plantingCleanout, _seedReturn)
    const updatedPlantingData = res.plantingData.length > 0 && res.plantingData.map(curr => {
      const totalPlantedAcres = parseFloat(curr.total_planted_acres)
      return {
        ...curr,
        total_planted_acres: !isNaN(totalPlantedAcres) ? totalPlantedAcres.toFixed(2) : '0.00'
      }
    })
    const updatedHarvestData = res.harvestData.length > 0 && res.harvestData.map(curr => {
      const totalAcres = parseFloat(curr.total_acres)
      return {
        ...curr,
        total_acres: !isNaN(totalAcres) ? totalAcres.toFixed(2) : '0.00'
      }
    })
    setPlantingCleanout(_plantingCleanout ? _plantingCleanout : false)
    setSeedReturn(_seedReturn ? _seedReturn : false)
    setHarvestCleanout(_harvestCleanout ? _harvestCleanout : false)
    setActivities(res.originalResponse.data)
    setPlantingData(updatedPlantingData.length > 0 ? updatedPlantingData : res.plantingData)
    setHarvestData(updatedHarvestData.length > 0 ? updatedHarvestData : res.harvestData)
    setStorageData(res.storageData)
    setReplantOrLost(res.activities.fields)
    setSilageDate(res.activities.silage_harvest_date ? res.activities.silage_harvest_date : null)

    if (res?.plantingData?.length > 0) {
      const allFields = res.plantingData.map(data => {
        return {
          ...data,
          isDisable: !data.total_planted_acres || data.total_planted_acres === '--' || data.total_planted_acres === '' || data.total_planted_acres === '0'
            || !data.planting_rate || data.planting_rate === '--' || data.planting_rate === '' || data.planting_rate === '0'
            || !data.date || data.date === '--' || data.date === ''
            || !data.crop || data.crop === '--' || data.crop === '' || data.crop === '0'
        }
      }
      )
      setFieldCompleteOrNot(allFields)
    }
    const plantingSummaryArray = stewardshipSummaryHelper(res.plantingData, 'planting', MAX_FALSEY_PLANTING_VALUES)
    const harvestSummaryArray = stewardshipSummaryHelper(res.harvestData, 'harvest', MAX_FALSEY_HARVEST_VALUES)
    let stewardshipSummary = plantingSummaryArray.map((item, i) => Object.assign({}, item, harvestSummaryArray[i]))
    setStewardshipSummaryDataArray(stewardshipSummary)
    if (res.activities.fields.length === 1 && (res.activities.fields[0].field_id === 'total_enogen_acres_id' || res.activities.fields[0].field_id === 'TotalEnogenAcres')) {
      setPlantingData([])
      setHarvestData([])
      setIsTotalfield(true)
      setStewardshipSummaryDataArray([])
    }
    else {
      setIsTotalfield(false)
    }
    const storageDataResultArray = res.storageData.map(obj => {
      if (obj.cleanout_date !== '' && obj.capacity > 0) {
        return true
      } else if (obj.cleanout_date !== '' || obj.capacity > 0) {
        return false
      } else {
        return null
      }
    })
    let storageSummary = false
    if (storageDataResultArray.every(val => val === true)) {
      storageSummary = true
    } else if (storageDataResultArray.every(val => val === null)) {
      storageSummary = null
    }

    console.log(res)

    setCleanoutSummaryData(prev => [
      {
        ...prev[0],
        harvest_summary: res.originalResponse?.data.harvest_status === 'Complete' ? true : res.originalResponse?.data.harvest_status === 'In Progress' ? false : null,
        planting_summary: res.originalResponse?.data.planting_status === 'Complete' ? true : res.originalResponse?.data.planting_status === 'In Progress' ? false : null,
        storage_summary: storageSummary
      }
    ])
  }, [])

  const getStewardshipFieldsCall = useCallback(() => {
    if (stewardship_activity_id) {
      getStewardshipDefaultData(stewardship_activity_id)
        ?.then(res => {
          if (res) {
            setCachedObject(res)
            setWidgetData(res)
            setStewardsUsers(res?.stewardData)
            getContractById(res.originalResponse.data.external_reference_id)
          } else {
            setStewardshipStatus()
            getContractById()
          }
        })
    }
  }, [
    getContractById, setWidgetData, stewardship_activity_id
  ])

  const patchStewardshipHistoryCall = useCallback(() => {
    if (modalContent) {
      let useInfoForStewardship = { ...userInfo }
      if (modalContent === 'PLANTING') {
        useInfoForStewardship = { ...userInfo, action: 'Edit planting stewardship' }
      } else if (modalContent === 'HARVEST') {
        useInfoForStewardship = { ...userInfo, action: 'Edit harvest stewardship' }
      } else {
        useInfoForStewardship = { ...userInfo, action: 'Edit storage cleanout' }
      }
      patchStewardshipHistoryData(contractData.contract_id, useInfoForStewardship)
    }
  }, [
    modalContent, contractData, userInfo
  ])

  useEffect(() => {
    getStewardshipFieldsCall()
  }, [getStewardshipFieldsCall])

  const { auth } = useContext(AuthContext)

  useEffect(() => {
    if(!auth.userInfo) return
    const user = auth.userInfo
    setUserInfo(
      {
        'user_id': user.user_id,
        'user_name': user.first + ' ' + user.last,
        'user_email': user.email,
        'system_name': 'GrowMore360'
      }
    )
  }, [auth])

  useEffect(() => {
    const mapFields = fields => {
      const fieldMap = new Map()
      fields.forEach(field => {
        fieldMap.set(field.field_id, field)
      })
      return fieldMap
    }

    if (contractData) {
      const filterData = {
        contract_id: contractData.contract_id,
        external_reference_id: contractData.external_reference_id,
        contract_year: moment(contractData.contract_start_execution).format('YYYY'),
        grower_name: `${nullParser(
          contractData.contract_details.grower_details.first
        )} ${nullParser(contractData.contract_details.grower_details.last)}`,
        reseller: nullParser(
          contractData.contract_details.reseller_details.reseller_name
        ),
        contract_type: nullParser(
          contractData.contract_details.display_details.contract_type
        ),
        contract_status: nullParser(contractData.contract_state),
        created_date: moment(contractData.created).format('MM-DD-YYYY'),
        new_contract_id: nullParser(contractData.new_contract_id)
      }
      setContractFilterData(filterData)
      set_init_fields(mapFields(contractData.contract_details.fields))

      setFieldDataStatus('LOADING')
      if (contractData.contract_details.grower_details?.salesforce_id) {
        setSapId(contractData.contract_details.grower_details.salesforce_id)
        getFieldsBySFDC_IDAndContractId(contractData.contract_details.grower_details.salesforce_id, contractData.contract_id).then(response => {
          if (!canceled.current) {
            if (response && response.farmArray && response.farmArray.length) {
              setFieldData(response)
              setFieldDataStatus()
            } else {
              setFieldData({})
              setFieldDataStatus('EMPTY')
            }
          }
        })
      } else {
        getGrower(contractData.contract_details.grower_details.sap_id, 'sap_id')
          .then(response => {
            if (response?.grower_sfdc_id) {
              setSapId(response.grower_sfdc_id)
              getFieldsBySFDC_IDAndContractId(response.grower_sfdc_id, contractData.contract_id).then(response => {
                if (!canceled.current) {
                  if (response && response.farmArray && response.farmArray.length) {
                    setFieldData(response)
                    setFieldDataStatus()
                  } else {
                    setFieldData({})
                    setFieldDataStatus('EMPTY')
                  }
                }
              })
            }
          })
      }
    }
  }, [contractData])

  useEffect(() => {
    if (!contractStatus) {
      const title = `${contractData.contract_start_execution.substring(0, 4)}: ${contractData.contract_details.grower_details.first} ${contractData.contract_details.grower_details.last} to ${contractData.contract_details.reseller_details.reseller_name}`
      setDetailViewTitle(title)

      let planting_count = -1
      contractData.contract_details.fields.forEach(obj => {
        planting_count = plantingData.findIndex(t => t.id === obj.field_id)
        if (planting_count !== -1) {
          if (!plantingData[planting_count].name)
            plantingData[planting_count].name = obj.field_name
          if (!plantingData[planting_count].total_planted_acres)
            plantingData[planting_count].total_planted_acres = obj.acres
          if (!plantingData[planting_count].planting_rate)
            plantingData[planting_count].planting_rate = obj.planting_rate
          if (!plantingData[planting_count].crop)
            plantingData[planting_count].crop = obj.average_yield
        }

        let harvest_count = -1
        harvest_count = harvestData.findIndex(t => t.id === obj.field_id)
        if (harvest_count !== -1) {
          if (!harvestData[harvest_count].name)
            harvestData[harvest_count].name = obj.field_name
          if (!harvestData[harvest_count].total_acres && !isActiveWidget)
            harvestData[harvest_count].total_acres = obj.acres
        }
      })
      setStewardshipStatus('SUCCESS')
    }
  }, [contractData, contractStatus, harvestData, plantingData, isActiveWidget])

  const updateRowData = (col, value, id, type, index) => {
    let setter
    switch (type) {
      case 'planting':
        setter = setPlantingData
        break
      case 'harvest':
        setter = setHarvestData
        break
      case 'storage':
        setter = setStorageData
        break
      default:
        return
    }
    setter(prev => {
      let newArray = prev.map(obj => {
        if (obj.id === id) {
          const newObject = { ...obj }
          newObject[col] = value
          return newObject
        } else {
          return obj
        }
      })
      return newArray
    })
  }

  useEffect(() => {
    const checkForStewardAccess = () => {
      const access = hasAccess('ANY', 'is-steward')
      const accessAll = hasAccess('ANY', 'all-steward')
      const createContract = hasAccess('ANY', 'create-contract')
      const signContract = hasAccess('ANY', 'sign-contract')
      const voidContract = hasAccess('ANY', 'void-contract')
      const approveContract = hasAccess('ANY', 'approve-contract')
      const amendContract = hasAccess('ANY', 'amend-contract')
      const deleteVoid = hasAccess('ANY', 'delete-void')

      if (hasAccess() === 'SUCCESS' || hasStewardAccess(stewardsUsers || []) === 'SUCCESS'
        || access === 'SUCCESS'
        || accessAll === 'SUCCESS'
        || createContract === 'SUCCESS'
        || signContract === 'SUCCESS'
        || voidContract === 'SUCCESS'
        || approveContract === 'SUCCESS'
        || amendContract === 'SUCCESS'
        || deleteVoid === 'SUCCESS') {
        setAllowAccess('SUCCESS')
      } else {
        setAllowAccess('FAILED')
      }
    }
    if (hasAccess() !== 'LOADING' || stewardsUsers.length > 0) {
      checkForStewardAccess()
    }
  }, [hasAccess, hasStewardAccess, stewardsUsers
  ])

  const patchHandler = async () => {
    setActivities(prev => {
      prev.stewardship_activity.cleanout.harvest.harvest_equipment = harvestCleanout
      prev.stewardship_activity.cleanout.planting.seed_return = seedReturn
      prev.stewardship_activity.cleanout.planting.planting_equipment = plantingCleanout
      return prev
    })
    const savedHarvestData = await harvestData.map(obj => {
      return {
        total_acres: nullParserReverse(obj.total_acres, '---'),
        harvest_date: nullParserReverse(obj.harvest_date, '---'),
        total_harvest: nullParserReverse(obj.total_harvest, '---'),
        yield_per_acre: nullParserReverse(obj.yield_per_acre, '---'),
        unit_type: obj.unit_type === 'bu' ? 'bushels' : obj.unit_type
      }
    })
    const savedPlantingData = await plantingData.map(obj => {
      return {
        crop: nullParserReverse(obj.crop, '---'),
        date: nullParserReverse(obj.date, '---'),
        planting_rate: nullParserReverse(obj.planting_rate, '---'),
        total_planted_acres: nullParserReverse(obj.total_planted_acres, '---')
      }
    })
    const savedCleanoutData = await storageData.map(obj => {
      return {
        location_name: obj.location_name,
        capacity: nullParserReverse(obj.capacity, '---'),
        cleanout_date: nullParserReverse(obj.cleanout_date, '---')
      }
    })


    setActivities(prev => {
      prev.stewardship_activity.fields.forEach((obj, index) => {
        obj.activity.planting = savedPlantingData[index]
        obj.activity.harvest = savedHarvestData[index]
      })
      prev.stewardship_activity.storage_locations = savedCleanoutData
      return prev
    })

    if (activities.stewards) {
      delete activities.stewards
    }
    setPatchPlantAndHarvestStatus('LOADING')
    patchStewardshipTable(stewardship_activity_id, activities).then(res => {
      if (res.status === 200) {
        getStewardshipFieldsCall()
        patchStewardshipHistoryCall()
        setPatchPlantAndHarvestStatus()
      }
    })
  }

  let content
  let title

  switch (modalContent) {
    case 'PLANTING':
      title = 'Planting cleanout'
      content = (
        <div className='w100% fxdc'>
          <div className='w100% df tal mb30 mt30 aic'>
            <input
              id='plantingCleanout'
              type='checkbox'
              className='ml20 w5%'
              checked={plantingCleanout}
              onChange={() => setPlantingCleanout(!plantingCleanout)}
            >
            </input>
            <label htmlFor='plantingCleanout' className='w100% tal fz18'>Seeding equipment is cleaned out according to stewardship training.</label>
          </div>
          <div className='w100% df tal mb30 mt30 aic'>
            <input
              id='seedReturn'
              type='checkbox'
              className='ml20 w5%'
              checked={seedReturn}
              onChange={() => setSeedReturn(!seedReturn)}
            >
            </input>
            <label htmlFor='seedReturn' className='w100% tal fz18'>Return any unused Enogen seed to your authorized dealer.</label>
          </div>
        </div>
      )
      break
    case 'HARVEST':
      title = 'Harvest cleanout'
      content = (
        <>
          <div className='w100% df tal mb30 mt30 aic'>
            <input
              id='harvestCleanout'
              type='checkbox'
              className='ml20 w5%'
              checked={harvestCleanout}
              onChange={() => setHarvestCleanout(!harvestCleanout)}
            >
            </input>
            <label htmlFor='harvestCleanout' className='w100% tal fz18'>Harvest equipment is cleaned out according to stewardship training.</label>
          </div>

        </>
      )
      break
    case 'STORAGE':
      title = 'Storage cleanout'
      content = (
        <div className="ml15">
          <p>Confirm changes to storage?</p>
        </div>
      )
      break
    case 'DISCARD':
      title = 'Discard changes?'
      content = (
        <div className='ml20'>
          <p>Your changes will not be saved.</p>
        </div>
      )
      break
    case 'SILAGE':
      title = 'Silage Declaration'
      content = (
        <div className='m20'>
          By Selecting, "Silage Harvest" you agree to the following terms:
          <br />
          <br />
          You will use commercially reasonable efforts to harvest your Enogen crop in the form of silage. If for any reason you harvest your Enogen crop as grain, you will follow all stewardship requirements applicable to Enogen grain included in your Enogen Feed agreement, including without limitation completing the Harvest Stewardship report, and you shall not sell or otherwise transfer any Enogen grain to any third party without advance written approval from Syngenta.
        </div>
      )
      break
    default:
      break
  }

  const modalCallBack = type => {
    setShowModal(!showModal)
    setModalContent(type)
    let eventType = `save_${type?.toLowerCase()}_clicked`
    if (type === 'DISCARD') {
      eventType = `cancel_${isActiveWidget?.toLowerCase()}_clicked`
    }
    trackEvent(eventType, { stewardshipActivityId: stewardship_activity_id })
  }

  const clickHandler = arg => {
    if (arg === 'SAVE') {
      trackEvent(`save_${isActiveWidget?.toLowerCase()}_confirmed`, { stewardshipActivityId: stewardship_activity_id })
      patchHandler()
    } else if (arg === 'DISCARD') {
      trackEvent(`cancel_${isActiveWidget?.toLowerCase()}_confirmed`, { stewardshipActivityId: stewardship_activity_id })
      setWidgetData(cachedObject)
    }
    setIsActiveWidget()
    setShowModal(false)
  }

  const showFieldLostFunc = () => {
    setShowFieldLost(true)
  }

  const showReplantFunc = () => {
    setShowReplant(true)
  }

  const handleViewContract = () => {
    const payload = {
      company_id: company_id
        ? company_id
        : contractFilterData.external_reference_id,
      detailView: {
        title: `${contractFilterData.contract_year}: ${contractFilterData.grower_name} to ${contractFilterData.reseller}`,
        previous: 'Back',
        new_contract_id: contractFilterData.new_contract_id
      },
      contract_id: contractFilterData.contract_id
    }
    trackEvent('view_contract_clicked', {
      from: company_id ? 'contractDashboard' : 'contractDetailView',
      companyId: company_id,
      contractId: contractFilterData.contract_id
    })
    dispatch({ type: 'GO_TO_CONTRACT', payload })
  }

  const assignEnogenFieldsFunc = () => {
    setShowAssignEnogenFields(!showAssignEnogenFields)
  }

  const handleAgreeSilage = async () => {
    setIsLoading(true)
    await patchSilageStewardship(stewardship_activity_id)
    await getStewardshipFieldsCall()
    setIsLoading(false)
    setShowModal(false)
    setIsActiveWidget('')
  }

  return (
    <>
      {(allowAccess === 'SUCCESS' && stewardshipStatus === 'SUCCESS' && !patchPlantAndHarvestStatus) &&
        <DetailView title={detailViewTitle} previous='Back' plantingData={plantingData} >
          <>
            <div className='posa t125 r25'>
              <Button type='default' text='Assign Enogen Fields' clickHandler={assignEnogenFieldsFunc} />
              <Button type='default' text='Replant' customClassName='ml10' clickHandler={showReplantFunc} />
              <Button type='default' text='Field lost' customClassName='ml10' onClick={showFieldLostFunc} />
              <Button
                type="success"
                text="Contract Details"
                clickHandler={() => handleViewContract()}
                customClassName="mb0 ml10"
              ></Button>
            </div>
            <ReplantView
              showReplant={showReplant}
              setShowReplant={setShowReplant}
              getStewardshipFieldsCall={getStewardshipFieldsCall}
              plantingData={plantingData}
              stewardship_activity_id={stewardship_activity_id}
              replantOrLost={replantOrLost}
              contract_id={contractData.contract_id}
              userInfo={userInfo}
              fieldCompleteOrNot={fieldCompleteOrNot}
            />
            <FieldLostView
              showFieldLost={showFieldLost}
              setShowFieldLost={setShowFieldLost}
              getStewardshipFieldsCall={getStewardshipFieldsCall}
              plantingData={plantingData}
              stewardship_activity_id={stewardship_activity_id}
              replantOrLost={replantOrLost}
              contract_id={contractData.contract_id}
              userInfo={userInfo}
              fieldCompleteOrNot={fieldCompleteOrNot}
            />
            {showAssignEnogenFields &&
              <AssignEnogenFieldsView
                showAssignEnogenFields={showAssignEnogenFields}
                setShowAssignEnogenFields={setShowAssignEnogenFields}
                status={fieldDataStatus}
                farmArray={fieldData.farmArray || []}
                fieldArray={fieldData.fields || []}
                contractYear={moment(contractData.contract_start_execution).format('YYYY')}
                _defaultFields={init_fields}
                getStewardshipFieldsCall={getStewardshipFieldsCall}
                contract_id={contractData.contract_id}
                sap_id={sapId}
                plantingData={activities?.stewardship_activity?.fields}
                growerData={contractData.contract_details.grower_details}
                contractType={contractData.contract_details.display_details.contract_type}
              />
            }
            <PlantingSteward isTotalfield={isTotalfield} plantingData={plantingData} setPlantingData={setPlantingData} updateRowData={updateRowData} modalCallBack={modalCallBack} isActiveWidget={isActiveWidget} setIsActiveWidget={handleSetActiveWidget} replantOrLost={replantOrLost} />
            <HarvestSteward isTotalfield={isTotalfield} setHarvestData={setHarvestData} harvestData={harvestData} updateRowData={updateRowData} modalCallBack={modalCallBack} isActiveWidget={isActiveWidget} setIsActiveWidget={handleSetActiveWidget} replantOrLost={replantOrLost} fieldCompleteOrNot={fieldCompleteOrNot} silageDate={silageDate} />
            <StorageCleanout storageData={storageData} updateRowData={updateRowData} modalCallBack={modalCallBack} isActiveWidget={isActiveWidget} setIsActiveWidget={handleSetActiveWidget} />
            <Modal
              autoHeight
              show={showModal}
              handleClose={handleClose}
            >
              <div data-testid='stewardshipModal' className='w700 h100% bgc-white bd1-s-lightgray bxshmodal bdrs-4'>
                <div className='w100% df jcsb'>
                  <p className='fz16 ml16 fw600'>{title}</p>
                </div>
                <hr className='mt0 bdnone bt1-s-lightgray' />
                <div className='df aic w100%'>
                  {content}
                </div>
                <hr className='mt0 bdnone bt1-s-lightgray' />
                <div className='w100% tar'>
                  {(() => {
                    switch (modalContent) {
                      case 'DISCARD':
                        return (
                          <>
                            <Button customClassName='mr10 bd1-s-red-500 c-red-700 ' text='Discard changes' clickHandler={() => clickHandler('DISCARD')} />
                            <Button customClassName='mr10' styleType='success' text='Keep editing' clickHandler={clickHandler} />
                          </>
                        )
                      case 'SILAGE':
                        return (
                          <>
                            <Button customClassName='mr10' styleType='default' text='Decline' clickHandler={() => setShowModal(false)} />
                            <Button customClassName='mr10' styleType='success' text={isLoading ? 'Loading...' : 'I Agree'} clickHandler={handleAgreeSilage} />
                          </>
                        )
                      default:
                        return (
                          <>
                            <Button customClassName='mr10' styleType='default' text='Cancel' clickHandler={() => setShowModal(false)} />
                            <Button customClassName='mr10' styleType='success' text='Save' clickHandler={() => clickHandler('SAVE')} />
                          </>
                        )
                    }
                  })()}

                </div>
              </div>
            </Modal>
          </>
          <>
            <StewardshipSummary
              status={stewardshipStatus === 'SUCCESS' ? null : 'EMPTY'}
              data={stewardshipSummaryDataArray}
              completeStatus={stewardshipStatus === 'SUCCESS' ? null : 'EMPTY'}
              completeData={cleanoutSummaryData}
              replantOrLost={replantOrLost}
            />
          </>
        </DetailView>
      }
      {
        (allowAccess === 'LOADING' || stewardshipStatus === 'LOADING' || patchPlantAndHarvestStatus === 'LOADING') && <TableStatus status='LOADING'></TableStatus>
      }
      {
        allowAccess === 'FAILED' && <AccessDeniedView />
      }
    </>
  )
}

export default StewardshipDetailView